module.exports = __webpack_public_path__ + "static/media/iphone3.8daf99be.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/iphone3.png
// module id = 236
// module chunks = 0